module.exports = __webpack_public_path__ + "static/img/rabbit.aec24bee.jpg";